module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', {
    staticClass: "overline pl-5"
  }, [_vm._v("\n  Appointment Types (" + _vm._s(_vm.filteredProducts.length) + ")\n  "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showArchived = !_vm.showArchived
      }
    }
  }, [(!_vm.showArchived) ? _c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("check_box_outline_blank")]) : _c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("check_box")]), _vm._v("\n    Show archived\n  ")], 1)], 1), _vm._v(" "), (_vm.members && _vm.members.length > 1) ? [_c('v-tabs', _vm._l((_vm.members), function(membership) {
    return _c('v-tab', {
      key: membership.id,
      on: {
        "click": function($event) {
          _vm.selectedPractitionerId = membership.user
        }
      }
    }, [_vm._v("\n        " + _vm._s(_vm.practitionerFullName(membership.user)) + "\n      ")])
  }), 1)] : _vm._e(), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.servicesSaveProductRequest,
      "message200": false
    },
    on: {
      "ok": _vm.requestOK
    }
  }), _vm._v(" "), _c('crud-table', {
    attrs: {
      "flat": "",
      "dense": "",
      "headers": _vm.productHeaders,
      "items": _vm.filteredProducts,
      "with-expand": true,
      "delete-icon": "archive",
      "delete-text": "Archive",
      "confirm-delete-title": "Are you sure you want to archive this appointment type?",
      "confirm-delete-tagline": "We will not delete this appointment type unless it has no appointments attached to it. If it has appointments, it will be archived. So previous appointments with this appointment type will retain this information, but this appointment type will no longer be visible",
      "wait-for-server": true,
      "delete-req-id": _vm.requests.service.products,
      "create-req-id": _vm.requests.service.products,
      "edit-req-id": _vm.requests.service.products,
      "close-on-edit": false,
      "dialog-width": 800,
      "with-inline-help": false,
      "loading": _vm.servicesSaveProductRequest.loading
    },
    on: {
      "add": _vm.addProduct,
      "edit": _vm.editProduct,
      "delete": _vm.deleteProduct,
      "input": _vm.itemsChanged
    },
    scopedSlots: _vm._u([{
      key: "duration",
      fn: function(props) {
        return [_vm._v("\n      " + _vm._s(props.value) + " mins\n    ")]
      }
    }, {
      key: "booking_notice_in_minutes",
      fn: function(props) {
        return [(props.value < 1440) ? _c('span', [_vm._v("Same day")]) : (props.value < 2880) ? _c('span', [_vm._v("Next day")]) : (props.value >= 2880) ? _c('span', [_vm._v("2 day")]) : _vm._e()]
      }
    }, {
      key: "price",
      fn: function(props) {
        return [_vm._v("\n      " + _vm._s(_vm.formatCurrency(props.item.currency, props.value)) + "\n    ")]
      }
    }, {
      key: "locations",
      fn: function(props) {
        return [(props.value && props.value.length === 0) ? [_c('span', {
          staticClass: "warning--text"
        }, [_c('v-icon', {
          staticClass: "mr-1 warning--text",
          attrs: {
            "small": ""
          }
        }, [_vm._v("warning")]), _vm._v(" Add a location\n        ")], 1)] : _vm._l((props.value), function(locId) {
          return [(_vm.$store.getters.getLocationById(locId) && _vm.$store.getters.getLocationById(locId).id) ? _c('v-chip', {
            staticClass: "v-chip--x-small",
            attrs: {
              "id": locId,
              "label": ""
            }
          }, [_c('span', {
            domProps: {
              "textContent": _vm._s(_vm.$store.getters.getLocationById(locId).name)
            }
          })]) : _c('span', [_vm._v(_vm._s(locId))])]
        })]
      }
    }, {
      key: "expand",
      fn: function(props) {
        return [_c('v-card', {
          attrs: {
            "full-width": "",
            "flat": ""
          }
        }, [_c('v-card-text', [_c('copy-text-field', {
          attrs: {
            "text-to-copy": ("https://book.appt.guru/?p=" + (_vm.selectedPractitioner.id) + "&at=" + (props.item.id)),
            "label": "Booking link",
            "prepend-icon": "link",
            "hint": "This link will take your client to a booking page with this appointment type pre-selected"
          }
        })], 1)], 1)]
      }
    }])
  }, [(_vm.selectedPractitioner && _vm.selectedPractitioner.id) ? _c('v-list', {
    attrs: {
      "slot": "addedit-cardtext-outer",
      "dense": "",
      "dark": ""
    },
    slot: "addedit-cardtext-outer"
  }, [_c('practitioner-list-item', {
    attrs: {
      "item": _vm.selectedPractitioner
    }
  }), _vm._v(" "), _c('v-divider')], 1) : _vm._e()], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3adb44b4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/settings/locations/ProductEdit.vue
// module id = 1393
// module chunks = 9